import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Subscription } from 'rxjs';
import { IBreadcrumbData } from '../../../../interfaces/breadcrumb-data.interface';
import { UploadService } from '../../services/uploads.service';


@Component({
  selector: 'app-uploads',
  templateUrl: './visitsUploads.component.html',
  styleUrls: ['./visitsUploads.component.scss']
})
export class VisitsUploadsComponent implements OnInit, OnDestroy, AfterViewInit {

  // tslint:disable-next-line:semicolon


  public panelOpenState = false;

  private fileInfoSubscription: Subscription;
  private uploadsSubscription: Subscription;

  /**
   * Nuevo método
   */

  public selectedFiles: FileList;
  public currentFile: File;
  public progress = 0;
  public message = '';
  public status;
  public progressLoaded;
  private filePickerButton;
  private fileChosenText;

  public fileInfos: Observable<any>;

  /**
   * BreadcrumbData
   */
  breadcrumbData: IBreadcrumbData;

  constructor(public dialogRef: MatDialogRef<VisitsUploadsComponent>, public uploadService: UploadService) {
    this.breadcrumbData = {
      titles: {
        icon: 'settings',
        links: [
          {
            text: 'Normas de uso de la planta para visitas'
          }
        ]
      },
      description: 'Aquí cargar las normas de visitas.',
      buttons: []
    };
  }

  ngOnInit() {
    this.fileInfoSubscription = this.uploadService.getFiles('visits').subscribe(files => {
      this.fileInfos = files.data;
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    if ( this.uploadsSubscription != null){
      this.uploadsSubscription.unsubscribe();
    }
    this.fileInfoSubscription.unsubscribe();
  }


  selectFile(event): void {
  this.selectedFiles = event.target.files;
}
  upload(): void {
    this.progress = 0;

    this.currentFile = this.selectedFiles.item(0);
    this.uploadsSubscription = this.uploadService.visitsUpload(this.currentFile).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round(100 * event.loaded / event.total);
          this.progressLoaded = event.loaded;
        } else if (event instanceof HttpResponse) {
          if (event.body != null){
            this.message = event.body.message;
            this.status  = event.body.status;
          } 
        } 
        if (event.type === 4){
          this.fileInfoSubscription = this.uploadService.getFiles('visits').subscribe(files => {
                this.fileInfos = files.data;
              });
        }
      },
      err => {
        this.progress = 0;
        this.message = 'Could not upload the file!';
        this.currentFile = undefined;
      });
    this.selectedFiles = undefined;
}

}
